import { render, staticRenderFns } from "./MitDataTableClient.vue?vue&type=template&id=6ab4837d&scoped=true"
import script from "./MitDataTableClient.vue?vue&type=script&lang=js"
export * from "./MitDataTableClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab4837d",
  null
  
)

export default component.exports